import styled from 'styled-components';

const MainContainer = styled.div`
  display: flex; // Use flex to have child elements side by side
  width: 100%; // Take the full width of its parent (ideally the viewport)
`;
export default MainContainer;
